export default __webpack_public_path__ + "static/media/calbank.98180f70.png";